// extracted by mini-css-extract-plugin
var _1 = "SidebarHeader__active___l3eFi";
var _2 = "SidebarHeader__navigationHeader___xUjib";
var _3 = "SidebarHeader__navigationHeaderItem___BFvOB";
var _4 = "SidebarHeader__wiggle___aVg6c";
export { _1 as "active", _2 as "navigationHeader", _3 as "navigationHeaderItem", _4 as "wiggle" }
